// container script for Google Analytics 4 functionality

jQuery( document ).ready(
	function(){
		// sets up our Google Analytics connector
		window.dataLayer = window.dataLayer || [];

        // file download language listener
        jQuery('.id_language_picker').on(
            'change',
            function () {
                window.dataLayer.push(
                    {
                        'fileLanguage': jQuery(this).val()
                    }
                )
            }
        );

        // our get started form
        jQuery('#gform_wrapper_21').on(
            'click',
            'input[type="radio"]', // filter out all but radio inputs
            function (e) {
                // here we create the object we'll send to GA4
                const selectedChoiceData = {
                    'event': 'formSelection',
                    'question': e.target.closest('li.gfield').querySelector('label').textContent,
                    'selectedResponse': e.target.value
                }

                // and here we push it
                window.dataLayer.push(selectedChoiceData)
            }
        )

        // facets
        function handleFacetSelections(e) {
            const payload = {
                'selection': e.target.value
            }
            if (e.target.classList.contains('facetwp-search')) {
                payload.event = 'facetwp-search';
                payload.question = e.target.placeholder;
            } else if (e.target.classList.contains('facetwp-dropdown')) {
                payload.event = 'facetwp-dropdown';
                payload.question = e.target.firstChild.firstChild.textContent;
            }

            window.dataLayer.push(payload)
        }

        // dropdowns and searches
        jQuery('.facetwp-facet').on(
            'change',
            handleFacetSelections
        );
        // tag clouds
        jQuery('.facetwp-type-checkboxes').on(
            'click',
            function(e) {
                const payload = {
                    'event': 'facetwp-checkbox',
                    'selection': e.target.attributes["data-value"].textContent,
                    'question': e.target.parentElement.attributes["data-name"].textContent
                }

                window.dataLayer.push( payload );
            }
        )
    }
);
